import CryptoJS from 'crypto-js';
// import { CHANNEL, VENDOR_NAME, VERSION } from './config';
// import VendorService from '../services/VendorService';
import VendorService from '../shared/services/VendorService';

const key = CryptoJS.enc.Utf8.parse('&F)J@NcRfTjWnZr4u7x!A%D*G-KaPdSg');
export const encrypt = (data) => {
    // data['channel'] = CHANNEL;
    // data['version'] = VERSION;
    // data['vendor_name'] = VENDOR_NAME;

    // if (VendorService.vendor_name) data['vendor_name'] = VENDOR_NAME;
    const msgString = JSON.stringify(data);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(msgString, key, {
        iv: iv
    });
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
};

export const decrypt = (cipher) => {
    let ciphertext = CryptoJS.enc.Base64.parse(cipher);

    const iv = ciphertext.clone();
    iv.sigBytes = 16;
    iv.clamp();
    ciphertext.words.splice(0, 4);
    ciphertext.sigBytes -= 16;

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
        iv: iv
    });
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};
if (process.env.NODE_ENV === 'development') {
    window.encrypt = encrypt;
    window.decrypt = decrypt;
}

export const decryptURL = (cipher) => {
    let ciphertext = CryptoJS.enc.Hex.parse(cipher);

    const iv = ciphertext.clone();
    iv.sigBytes = 16;
    iv.clamp();
    ciphertext.words.splice(0, 4);
    ciphertext.sigBytes -= 16;

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
        iv: iv
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};
